(function () {
  var root = document.querySelector('[data-somsoc-sticky-buy]');
  if (!root) return;

  var purchaseMode = root.dataset.purchaseMode || 'cart';
  var isRaffleMode = purchaseMode === 'raffle';
  var productRoot = document.querySelector('[data-product-root]');
  var form = productRoot ? productRoot.querySelector('form.shopify-product-form') : document.querySelector('form.shopify-product-form');
  var originalAddButton = form ? form.querySelector('.add-to-cart') : null;
  var productJson = root.querySelector('[data-somsoc-product-json]');
  if (!productJson) return;
  if (!isRaffleMode && (!form || !originalAddButton)) return;

  var data = JSON.parse(productJson.textContent);
  var variants = data.variants || [];
  var options = data.options || [];
  var primaryPosition = Number(root.dataset.primaryOptionPosition || 1);
  var hasOptions = root.dataset.hasOptions === 'true';
  var selected = {};
  var currentVariantId = Number(root.dataset.currentVariantId);
  var currentVariant = variants.find(function (variant) { return Number(variant.id) === currentVariantId; }) || variants[0];

  var priceEl = root.querySelector('[data-somsoc-sticky-price]');
  var addButton = root.querySelector('[data-somsoc-sticky-add]');
  var optionTrigger = root.querySelector('[data-somsoc-option-trigger]');
  var optionPanel = root.querySelector('[data-somsoc-option-panel]');
  var optionGroups = root.querySelector('[data-somsoc-option-groups]');
  var addLabel = root.querySelector('[data-somsoc-sticky-add-label]');
  var addProgress = root.querySelector('[data-somsoc-sticky-progress]');
  var addStatus = root.querySelector('[data-somsoc-sticky-status]');
  var mq = window.matchMedia('(max-width: 767px)');
  var labels = {
    add: root.dataset.addLabel || 'カートに追加',
    raffle: root.dataset.raffleLabel || '抽選に申し込む',
    option: root.dataset.optionLabel || 'サイズ',
    soldOut: root.dataset.soldOutLabel || 'SOLD OUT',
    loading: root.dataset.loadingLabel || 'LOADING',
    added: root.dataset.addedLabel || 'ADDED'
  };
  var progressTimer = null;
  var resetTimer = null;
  var progressValue = 0;
  var raffleRefreshTimer = null;

  function isElementVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return !!(rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight);
  }

  function raffleRoot() {
    var rootEl = document.getElementById('shopify-raffle') || document.querySelector('.raffle-container');
    if (!rootEl) return null;
    return rootEl.closest('.shopify-block.shopify-app-block') || rootEl;
  }

  function raffleControl() {
    var container = raffleRoot();
    if (!container) return null;
    var candidates = Array.prototype.slice.call(container.querySelectorAll('button, a[href], input[type="button"], input[type="submit"]'));
    return candidates.find(function (element) {
      var rect = element.getBoundingClientRect();
      var text = (element.innerText || element.value || element.getAttribute('aria-label') || '').trim();
      return rect.width > 0 && rect.height > 0 && text.length > 0;
    }) || null;
  }

  function isDisabled(element) {
    return !!(element && (element.disabled || element.getAttribute('aria-disabled') === 'true'));
  }

  function raffleAction() {
    var control = raffleControl();
    if (!control || isDisabled(control)) return null;
    return control;
  }

  function raffleActionLabel() {
    var control = raffleControl();
    if (!control) return labels.raffle;
    return (control.innerText || control.value || control.getAttribute('aria-label') || labels.raffle).replace(/\s+/g, ' ').trim();
  }

  function variantOption(variant, position) {
    return variant ? variant['option' + position] : null;
  }

  function seedSelected(variant) {
    options.forEach(function (option) {
      selected[option.position] = variantOption(variant, option.position) || (option.values && option.values[0]);
    });
  }

  function selectedVariant() {
    return variants.find(function (variant) {
      return options.every(function (option) {
        return variantOption(variant, option.position) === selected[option.position];
      });
    }) || null;
  }

  function money(cents) {
    if ((root.dataset.currency || 'JPY') === 'JPY') {
      return '¥' + new Intl.NumberFormat('ja-JP', {
        maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    }

    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: root.dataset.currency,
      maximumFractionDigits: 0
    }).format((cents || 0) / 100);
  }

  function labelForTrigger() {
    if (!hasOptions || !optionTrigger) return;
    var primaryValue = selected[primaryPosition];
    optionTrigger.textContent = primaryValue || labels.option;
  }

  function setAddState(variant) {
    if (!addButton) return;
    var raffleMainControl = isRaffleMode ? raffleControl() : null;
    var available = !!(variant && variant.available);
    if (isRaffleMode && raffleMainControl) available = available && !isDisabled(raffleMainControl);
    addButton.disabled = !available;
    if (!addLabel) return;
    if (!available && !isRaffleMode) {
      addLabel.textContent = labels.soldOut;
      return;
    }
    var nextLabel = isRaffleMode ? raffleActionLabel() : labels.add;
    if (addLabel.textContent !== nextLabel) addLabel.textContent = nextLabel;
  }

  function setProgress(value) {
    progressValue = Math.max(0, Math.min(100, value));
    if (addProgress) addProgress.style.transform = 'scaleX(' + (progressValue / 100) + ')';
    if (addStatus) addStatus.textContent = progressValue >= 100 ? labels.added : labels.loading + ' ' + Math.round(progressValue) + '%';
  }

  function startAddAnimation() {
    if (!addButton || addButton.disabled) return;
    window.clearInterval(progressTimer);
    window.clearTimeout(resetTimer);
    addButton.classList.remove('is-success');
    addButton.classList.add('is-loading');
    setProgress(3);
    progressTimer = window.setInterval(function () {
      var step = progressValue < 70 ? 9 : progressValue < 90 ? 5 : 2;
      setProgress(Math.min(96, progressValue + step + Math.floor(Math.random() * 4)));
    }, 45);
  }

  function finishAddAnimation() {
    window.clearInterval(progressTimer);
    addButton.classList.add('is-loading');
    progressTimer = window.setInterval(function () {
      setProgress(Math.min(100, progressValue + Math.max(6, Math.ceil((100 - progressValue) / 2))));
      if (progressValue >= 100) {
        window.clearInterval(progressTimer);
        addButton.classList.remove('is-loading');
        addButton.classList.add('is-success');
        resetTimer = window.setTimeout(resetAddAnimation, 520);
      }
    }, 36);
  }

  function resetAddAnimation() {
    window.clearInterval(progressTimer);
    window.clearTimeout(resetTimer);
    if (addButton) addButton.classList.remove('is-loading', 'is-success');
    setProgress(0);
  }

  function syncNativeOption(position, value) {
    if (!productRoot) return;
    var selector = '[data-single-option-selector][data-position="' + position + '"]';
    var escaped = window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"');
    var input = productRoot.querySelector(selector + '[value="' + escaped + '"]');
    if (!input) return;

    if (input.tagName === 'BUTTON') {
      input.click();
      return;
    }

    if (input.type === 'radio') {
      input.checked = true;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refreshFromVariant(variant) {
    currentVariant = variant || selectedVariant();
    if (currentVariant) {
      seedSelected(currentVariant);
      root.dataset.currentVariantId = currentVariant.id;
      if (priceEl) priceEl.textContent = money(currentVariant.price);
    }
    labelForTrigger();
    setAddState(currentVariant);
    renderChoices();
  }

  function possibleVariantFor(position, value) {
    var trial = Object.assign({}, selected);
    trial[position] = value;
    return variants.find(function (variant) {
      return options.every(function (option) {
        return trial[option.position] == null || variantOption(variant, option.position) === trial[option.position];
      });
    }) || variants.find(function (variant) {
      return variantOption(variant, position) === value;
    });
  }

  function renderChoices() {
    if (!hasOptions || !optionGroups) return;
    optionGroups.innerHTML = '';

    options.forEach(function (option) {
      var group = document.createElement('div');
      group.className = 'somsoc-mobile-sticky-buy__group';

      var title = document.createElement('span');
      title.className = 'somsoc-mobile-sticky-buy__group-title';
      title.textContent = option.name;
      group.appendChild(title);

      var choices = document.createElement('div');
      choices.className = 'somsoc-mobile-sticky-buy__choices';
      if ((option.values || []).length >= 5) {
        choices.classList.add('is-fixed-five');
      } else {
        choices.style.setProperty('--somsoc-option-count', Math.max(1, (option.values || []).length));
      }

      (option.values || []).forEach(function (value) {
        var choiceVariant = possibleVariantFor(option.position, value);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'somsoc-mobile-sticky-buy__choice';
        button.textContent = value;
        button.dataset.position = option.position;
        button.dataset.value = value;
        if (selected[option.position] === value) button.classList.add('is-selected');
        if (choiceVariant && !choiceVariant.available) button.classList.add('is-disabled');

        button.addEventListener('click', function () {
          selected[option.position] = value;
          syncNativeOption(option.position, value);
          window.setTimeout(function () {
            var nextVariant = selectedVariant() || choiceVariant;
            if (nextVariant) refreshFromVariant(nextVariant);
            closePanel();
          }, 0);
        });

        choices.appendChild(button);
      });

      group.appendChild(choices);
      optionGroups.appendChild(group);
    });
  }

  function openPanel() {
    if (!optionPanel || !optionTrigger) return;
    optionPanel.hidden = false;
    optionTrigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('somsoc-sticky-buy-panel-open');
  }

  function closePanel() {
    if (!optionPanel || !optionTrigger) return;
    optionPanel.hidden = true;
    optionTrigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('somsoc-sticky-buy-panel-open');
  }

  function togglePanel() {
    if (!optionPanel || optionPanel.hidden) {
      openPanel();
      return;
    }
    closePanel();
  }

  function updateHeight() {
    var bar = root.querySelector('.somsoc-mobile-sticky-buy__bar');
    if (!bar) return;
    document.documentElement.style.setProperty('--somsoc-sticky-buy-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
  }

  function updateVisibility() {
    var shouldShow = mq.matches;
    var originalAction = isRaffleMode ? (raffleAction() || raffleRoot()) : originalAddButton;
    var shouldDockOut = shouldShow && isElementVisible(originalAction);

    if (shouldShow) {
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.remove('is-hidden');
        root.classList.toggle('is-docked-out', shouldDockOut);
      });
    } else {
      root.classList.remove('is-docked-out');
      root.classList.add('is-hidden');
    }
  }

  function submitOriginalForm() {
    if (addButton.disabled) return;
    startAddAnimation();
    window.setTimeout(function () {
      originalAddButton.click();
    }, 320);
  }

  function submitRaffleAction() {
    if (addButton.disabled) return;
    var action = raffleAction();
    if (action) {
      action.click();
      return;
    }

    var container = raffleRoot();
    if (container) {
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      updateVisibility();
    }
  }

  function refreshRaffleActionState() {
    if (!isRaffleMode) return;
    window.clearTimeout(raffleRefreshTimer);
    raffleRefreshTimer = window.setTimeout(function () {
      setAddState(currentVariant);
      updateVisibility();
    }, 50);
  }

  function refreshRaffleActionStateNow() {
    if (!isRaffleMode) return;
    setAddState(currentVariant);
    updateVisibility();
  }

  seedSelected(currentVariant);
  refreshFromVariant(currentVariant);
  document.body.classList.add('somsoc-sticky-buy-active');
  updateHeight();
  updateVisibility();

  if (optionTrigger) optionTrigger.addEventListener('click', togglePanel);
  if (addButton) addButton.addEventListener('click', isRaffleMode ? submitRaffleAction : submitOriginalForm);

  document.addEventListener('theme:variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    if (event.detail.productRootEl && productRoot && event.detail.productRootEl !== productRoot) return;
    refreshFromVariant(event.detail.variant);
  });

  document.body.addEventListener('baseline:cart:afteradditem', function (event) {
    if (isRaffleMode) return;
    if (!form || !event.detail || event.detail.sourceId !== form.id) return;
    finishAddAnimation();
  });

  if (productRoot) {
    productRoot.addEventListener('baseline:productform:error', function () {
      resetAddAnimation();
    });
  }

  if (isRaffleMode) {
    var raffleObserver = new MutationObserver(refreshRaffleActionState);
    raffleObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(refreshRaffleActionStateNow, 500);
    window.setTimeout(refreshRaffleActionStateNow, 1500);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', function () {
    updateHeight();
    updateVisibility();
  });
  mq.addEventListener('change', updateVisibility);
})();
